import type { ProductRewardSearchResult } from '@brandclub/common-ui';
import { useEffect } from 'react';

import { useDtcSiteProduct } from '@/api/cache/dtcProductQueryOptions';
import { autoUpdateDTCProducts } from '@/api/rest/product';
import { resolveStacklineSkuFromUrlParams } from '@/utils/bcProductMetadataUtils';
import { useBCRouting } from '../../providers/BCRoutingContextProvider';

export const useAutoUpdateCurrentDtcProducts = (currentBrandclubProduct?: ProductRewardSearchResult) => {
  const bcRouting = useBCRouting();
  const { data: dtcProduct } = useDtcSiteProduct();

  useEffect(() => {
    if (currentBrandclubProduct && dtcProduct)
      (async () => {
        try {
          const productToAutoUpdate: {
            stacklineSku: string;
            dtcProductPageUrl: string;
            dtcSku: string | undefined;
          }[] = [];
          const { dtcVariantId: variantId } = resolveStacklineSkuFromUrlParams(bcRouting.location.search);
          let dtcProductPageUrl = `https://${bcRouting.location.hostname}/products/${dtcProduct.handle}`;
          if (variantId) {
            dtcProductPageUrl = `https://${bcRouting.location.hostname}/products/${dtcProduct.handle}?variant=${variantId}`;
          }
          const dtcSku = variantId
            ? dtcProduct?.variants?.find((x) => `${x.id}` === variantId)?.sku
            : dtcProduct?.variants?.[0].sku;
          productToAutoUpdate.push({
            stacklineSku: currentBrandclubProduct.stacklineSku,
            dtcProductPageUrl,
            dtcSku,
          });
          if (currentBrandclubProduct?.matchedProducts && currentBrandclubProduct?.matchedProducts?.length >= 0) {
            for (const matchedProduct of currentBrandclubProduct.matchedProducts) {
              productToAutoUpdate.push({
                stacklineSku: matchedProduct.stacklineSku,
                dtcProductPageUrl,
                dtcSku: dtcProduct?.variants?.[0].sku,
              });
            }
          }
          await autoUpdateDTCProducts(productToAutoUpdate);
        } catch (error) {
          console.error(error);
        }
      })();
  }, [bcRouting.location.hostname, bcRouting.location.search, currentBrandclubProduct, dtcProduct]);
};
